
<div class=" bg">
    <app-header 
  [fixed]="true"
  [navbarBrandFull]="{src: 'assets/img/brand/logowh.png', height: 30, alt: 'Robo-Advisor Logo'}"
  [navbarBrandMinimized]="{src: 'assets/img/brand/logowh.png', height: 30, alt: 'Robo-Advisor Logo'}"
  [sidebarToggler]="false"
  [mobileSidebarToggler]="false"
  [asideMenuToggler]="false"
  [mobileAsideMenuToggler]="false"
  >
  
    <!-- Dropdown Menu -->
    <ul class="nav navbar-nav ml-auto">
    <li class="nav-item dropdown" dropdown placement="bottom right">

      <a class="nav-link" style="color:white" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false" dropdownToggle (click)="false">
         Mon Compte  <i  style style="padding-left:5px" class="icon-user icons"></i>&nbsp;&nbsp;
      </a>

      <div class="dropdown-menu dropdown-menu-right" *dropdownMenu aria-labelledby="simple-dropdown">
        <div class="dropdown-header text-center"><strong >Bonjour {{email$}}</strong></div>
        <a (click)="Gotoprofile()" class="dropdown-item" ><i class="fa fa-gear"></i>Paramétres</a>
        <a (click)="GotoprofileSecurity()" class="dropdown-item" ><i class="fa fa-lock"></i>Sécurité</a>
        <a (click)="GotoSupport()" class="dropdown-item" ><i class="fa fa-question-circle"></i>Support</a>
        <a (click)="logout(mymodal)" class="dropdown-item" ><i class="fa fa-sign-out"></i>Se déconnecter</a>

        <!-- model start here  -->
        <ng-template #mymodal let-modal>
          <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title" style="color:#6600ff; font-weight: bold; font-size: 18px;">DÉCONNEXION</h4>
            <button type="button" class="close"    aria-label="Close" (click)="modal.dismiss('Cross click')">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body" style="font-size: 16px;">
            Êtes-vous sûr de quitter Robo Advisor ?
           </div>
          <div class="modal-footer">
           
            <button type="button" class="btn modele2" data-dismiss="modal" (click)="modal.dismiss('Cross click')" >Fermer</button>
            <button type="button" class="btn  modele" data-dismiss="modal" (click)="modal.close('Save click'); signout();">Confirmer</button>
            <!-- <button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">Ok</button> -->
          </div>
        </ng-template>
        <!-- model End here  -->

        <!-- <ng-template >
          <a class="dropdown-item"  [routerLink]="['/']" routerLinkActive="router-link-active"><i class="fa fa-unlock"></i>Se connecter</a>
        </ng-template> -->
        <!-- <a class="dropdown-item"><i class="fa fa-user"></i>Mon profil</a>
        <a class="dropdown-item" [routerLink]="['/auth/info']" routerLinkActive="router-link-active" ><i class="fa fa-wrench"></i>Auth Debug</a> -->
      </div>
      
    </li>
  </ul>
 
</app-header>
<div class="container-fluid background">
    <div class="row padding-top-20">
        <div class="col-12 col-sm-12 col-md-10 col-lg-10 col-xl-8 offset-md-1 offset-lg-1 offset-xl-2 padding-horizontal-40">
            <div class="row">
                <div class="col-12 main-wrapper">
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <div id="template" class="row panel-wrapper">
                                <div class="col-12 panel-header basket-header">
                                    <div class="row">
                                        <div class="col-12 creditcard-title">
                                            <span class="description">Section 1</span><br><span class="emphasized"> Informations de votre abonnement</span>
                                        </div>
                                    </div>
                                </div>
                             
        <div class="col-12 panel-body creditcard-body1">
			
                                    <form [formGroup]="paymentForm" action="#" method="post" target="_self">
										<fieldset>
                                            <label for="card-ccv">Id abonnement</label><br>
											<input type="text" class="form-control" id="OrdreID"formControlName="OrdreID" name="OrdreID" placeholder={{orderch}} disabled>
                                        </fieldset>
                                        <fieldset>
                                            <label for="card-name">Nom de l'abonnement</label><br>
											<input type="useremail" class="form-control" id="Nom" name="Nom" placeholder={{orderProducts}} disabled>
                                        </fieldset>
                                        <fieldset>
                                            <label for="card-number">Type de plan</label><br>
											<input type="text" class="form-control"  formControlName="plan"  placeholder={{Plan}} disabled>
                                        </fieldset>
                                        <fieldset>
                                            <label for="card-expiration">Durée de l'abonnement</label><br>
											<input type="text" class="form-control" id="Durée" formControlName="Durée" name="Durée" placeholder={{duration}}  disabled>
                                        </fieldset>
                                       
										
                                    </form>
								
                                </div>
                 <div class="col-12 panel-footer1 creditcard-footer1">
                                   

                              
                                    <label for="card-ccv">Montant à Payer</label><br>
                                    <input type="text" class="form-control" id="total"formControlName="adresse" name="total" placeholder={{Amount}} disabled>
                               
                             </div>
                    </div>

                      
             
                        </div>
                        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <div class="row panel-wrapper">
                                <div class="col-12 panel-header creditcard-header">
                                    <div class="row">
                                        <div class="col-12 creditcard-title">
                                            <span class="description">Section 2</span><br><span class="emphasized">Vos informations personnelles</span>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="col-12 panel-body creditcard-body1">
                                    <form (ngSubmit)="Payment()"target="_self"  [formGroup]="registerForm" >
                                        <fieldset>
                                            <label for="card-name">Email</label><br>
											<input type="useremail" class="form-control" id="Email"  placeholder={{email$}} disabled>
                                        </fieldset>
                                        <fieldset>
                                            <label for="card-number">Nom </label><br>
											<input type="text" class="form-control"  formControlName="nom"  placeholder={{fullname$[0]}} >
                                           
                                        </fieldset>
                                        <fieldset>
                                            <label for="card-ccv">Prénom</label><br>
											<input type="text" class="form-control" formControlName="prenom"  placeholder={{fullname$[1]}} >
                                        </fieldset>
                                        <div class="popup" *ngIf="showPopups">
                                            <div class="popup-content">
                                                <h2  style="color:red; font-size: 25px;"><i class="fas fa-exclamation-triangle"></i></h2>
                                              <p Style="font-size: 18px; line-height: 25px;" >Vous avez deja un Abonnement active. Etes vous sur de l'extendre </p>
                                              <button Style="background-color :#722add ; font-size: 15px; width: fit-content; height: fit-content;" (click)="closePopups()">Annuler</button>
                                              <button Style="background-color :#722add ; font-size: 15px; width: fit-content; height: fit-content;" (click)="Payment()">Procéder</button>
                                            </div>
                                          </div>
                                        <div class="popup" *ngIf="showPopup">
                                            <div class="popup-content">
                                                <h2  style="color:red; font-size: 25px;"><i class="fas fa-exclamation-triangle"></i></h2>
                                              <p Style="font-size: 18px; line-height: 25px;" >Veuillez re-saisir vos informations personnelles <br>pour confirrmer leur validité.</p>
                                              <button Style="background-color :#722add ; font-size: 15px; width: fit-content; height: fit-content;" (click)="closePopup()">Fermer</button>
                                             
                                            </div>
                                          </div>

                                      
                                    
                                    
                                        <fieldset>
                                            <label for="card-expiration">Numéro de téléphone</label><br>
											<input type="text" class="form-control" formControlName="tel"  placeholder= {{tel$}} >
                                        </fieldset>
                                        <fieldset>
                                            <label for="card-ccv">Adresse</label><br>
											<input type="text" class="form-control" formControlName="adresse" placeholder={{adresse$}} >
                                        </fieldset>
									

                                        <div class="btns">
                                            <button type="submit" >Continuer</button>
                                    
                                        </div>
                                    </form>
                                  
                    
                                </div>
               
                                       
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

</div>